import Api from './api';

const RenunciaReceitaService = {
    cadastro: async (params) => {
        const response = await Api.post('/restrito/renunciareceita/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },

    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/renunciareceita/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletar: (id) => {
        Api.delete(`/restrito/renunciareceita/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    renunciaReceitaEdit: async (id) => {
        const response = await Api.get(`/restrito/renunciareceita/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/restrito/renunciareceita/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/restrito/renunciareceita/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    }
}

export default RenunciaReceitaService;